import Image from 'next/image'
import { SpecialLayoutObject } from '@/app/(app)/(special-layout)/special-layout-objects'
import VideoComponent from '../media/videoComponent'
import { Media } from '@/payload-types'
import ButtonComponent from '../button/button'
import ShareLinkIcons from '../share-link-icons/shareLinkIcons'

interface IProps {
  data?: SpecialLayoutObject
}

const button = {
  id: 'read_report',
  name: 'read_report',
  label: 'Read More',
  backgroundColor: 'white',
  iconType: 'ArrowRight',
  updatedAt: '',
  createdAt: '',
}

const typeStyles: Record<
  string,
  {
    wrapper: string
    title: string
    sectionText: string
    innerWrapper: string
    contentWrapper: string
    showMedicalNotice?: boolean
    imageStyle?: string
    textWrapper?: string
  }
> = {
  home: {
    wrapper: 'flex-nowrap xl:pt-7 !pt-3',
    title: 'sm:text-[45px]',
    sectionText: 'block',
    innerWrapper:
      'flex items-center flex-col justify-center xl:flex-row xl:h-[325px]',
    contentWrapper: '',
    textWrapper: 'max-w-[574px] h-[295px]',
    imageStyle: 'md:h-[325px] md:w-[565px] h-[200px] w-[355px]',
  },
  medical: {
    wrapper: 'px-5 w-[1200px]',
    title: 'sm:text-[40px]',
    sectionText: 'hidden sm:block',
    innerWrapper: 'flex min-[1000px]:flex-row flex-col',
    contentWrapper: 'flex place-content-center',
    textWrapper: 'max-w-[528px] ',
    showMedicalNotice: true,
  },
  default: {
    wrapper: 'px-5 w-[1200px]',
    title: 'sm:text-[45px]',
    sectionText: 'hidden sm:block',
    innerWrapper: 'flex min-[1000px]:flex-row flex-col',
    textWrapper: 'max-w-[528px] ',
    contentWrapper: 'flex place-content-center',
  },
}

export const PageDesignWrapper = ({ data }: IProps) => {
  const typeKey = data?.type || 'default'
  const styles = typeStyles[typeKey] || typeStyles.default

  const mediaData: Media = {
    id: `${data?.title}`,
    title: '',
    createdAt: '',
    updatedAt: '',
    url: data?.iframeSrc,
    coverImage: data?.coverImage,
  }

  return (
    <div className={`flex flex-col pt-6 pb-6 md:pb-14 ${styles.wrapper}`}>
      <span
        className={`text-white ${styles.title} text-[25px] font-semibold sm:leading-[67px] mb-[10px]`}
      >
        {data?.title}
      </span>

      {styles.showMedicalNotice && (
        <div className="text-white font-semibold text-sm sm:text-lg pb-5 sm:pb-[34px]">
          <span>
            {`All medical personnel must treat patients impartially, regardless of religion or support
          for the State of Israel. Violating this moral code, especially given their control over
          patients' lives, makes the individuals listed here exceptionally `}
            <em>
              <u>dangerous</u>
            </em>
            .
          </span>
        </div>
      )}

      <div className={styles.contentWrapper}>
        <div className={styles.innerWrapper}>
          {data?.iframeType === 'Video' && (
            <div className={`${styles.imageStyle}`}>
              <VideoComponent videoData={mediaData} embeddedVideo />
            </div>
          )}
          
          {data?.iframeType === 'Image' && (
            <Image
              src={data?.iframeSrc || ''}
              alt={data?.sectionTitle || ''}
              height={500}
              width={565}
              className={`rounded-lg border border-white ${styles.imageStyle}`}
            />
          )}

          <div className={`flex flex-col min-[1000px]:ml-[30px] text-white mt-[10px] xl:mt-[0px] xl:h-[-webkit-fill-available] ${styles.textWrapper}`}>
            <p className="text-[20px] sm:text-[30px] font-semibold leading-[25px] sm:leading-[40px] mb-[15px]">
              {data?.sectionTitle}
            </p>
            <p
              className={`${styles.sectionText} text-[16px] font-semibold leading-[24px] mb-[20px] overflow-auto pr-[10px]`}
            >
              {data?.sectionText}
            </p>

            <div className="mt-auto flex flex-row items-center">
              <ButtonComponent
                buttonData={button}
                url={data?.link}
                buttonCSS="bg-opacity-25 !justify-center specialLayoutButton text-sm sm:text-base font-medium sm:font-semibold rounded-lg border border-white mr-[30px] h-[40px] sm:h-[45px] w-[130px] sm:w-[160px] hover:bg-opacity-50"
              />
              <ShareLinkIcons
                urlToShare={data?.linkToShare}
                pageTitle=""
                specialLayout
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PageDesignWrapper
